import type { Absence } from "../types";

export function sameCaseIds(
  absences: Absence[],
  selectedId: number | null,
): Set<number> {
  if (null === selectedId) {
    return new Set();
  }

  const neighbours = new Map<number, number[]>();

  const link = (from: number, to: number) => {
    neighbours.set(from, [...(neighbours.get(from) ?? []), to]);
  };

  for (const absence of absences) {
    if (null === absence.sameCaseAbsenceId) {
      continue;
    }

    link(absence.id, absence.sameCaseAbsenceId);
    link(absence.sameCaseAbsenceId, absence.id);
  }

  const seen = new Set<number>([selectedId]);
  const queue = [selectedId];

  while (0 < queue.length) {
    const current = queue.shift() as number;

    for (const neighbour of neighbours.get(current) ?? []) {
      if (seen.has(neighbour)) {
        continue;
      }

      seen.add(neighbour);
      queue.push(neighbour);
    }
  }

  seen.delete(selectedId);

  return seen;
}

export function pointsAt(
  absences: Absence[],
  fromId: number,
  targetId: number,
): boolean {
  const linkOf = new Map(
    absences.map((absence) => [absence.id, absence.sameCaseAbsenceId]),
  );

  const seen = new Set<number>();
  let current: number | null | undefined = fromId;

  while (null !== current && undefined !== current && !seen.has(current)) {
    if (current === targetId) {
      return true;
    }

    seen.add(current);
    current = linkOf.get(current);
  }

  return false;
}
